import { connect } from "react-redux";
import ActionLog from "./actionLog";
import actionCreators from "./redux/actionCreators";
import { getActionLogType, getInProgress } from "./redux/selectors";
const mapStateToProps = (state) => ({
    inProgress: getInProgress(state),
    actionLogType: getActionLogType(state)
});
const mapDispatchToProps = (dispatch) => ({
    onActionLogTypeChange: (actionLogType) => {
        dispatch(actionCreators.setActionLogType(actionLogType));
    },
    onExport: (type, filter, sort) => {
        dispatch(actionCreators.export(type, filter, sort));
    }
});
export default connect(mapStateToProps, mapDispatchToProps)(ActionLog);
